import React, { Component, useEffect, useState } from "react";
import Amplify, {Auth, Hub} from "aws-amplify";
import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { bindActionCreators } from "redux";
import { toast } from 'react-toastify';
// Auth
import {
  loginSuccess,
  cognitoLoginSuccess,
  cognitoLoginFail,
  logout,
} from "../../actions/auth";
// API Urls
import APIUrls from "../../constants/ApiUrls";
import { APIManager } from "../../utils/api";
import LoaderButton from "../../components/LoaderButton";
import "./ConfirmVerification.scss";
import { codeAndParamsFromUrl, addEventNameToEndpoint } from "../../utils/common";
import { isOnboarding } from "../../utils/userState";
import imgSignup from '../../assets/images/ilustration-signup-gartner.png';
import imgCamelLogo from '../../assets/images/content-camel-logo.png';

const authSettings = {
  mandatorySignIn: false,
  region: "us-west-2",
  userPoolId: "",
  identityPoolId: "",
  userPoolWebClientId: "",
  oauth: {
    domain: "",
    scope: ["email", "openid", "aws.cognito.signin.user.admin", "profile"],
    redirectSignIn: "http://localhost:3000/sso",
    redirectSignOut: "http://localhost:3000/sso",
    responseType: "code"
  }
};

const analyticsSettings = {
  disabled: true,
  autoSessionRecord: true,
  AWSPinpoint: {
    appId: process.env.REACT_APP_PINPOINT_ID, 
    region: 'us-east-1',
    endpoint: {
      attributes: {
      },
      channelType: "EMAIL",
      optOut: 'NONE',
      userId: "",
      userAttributes: {
      }
    },
  }
};

const FormType = {
  EMAIL_LOOKUP: "emailLookup",
  OKTA: "Okta"
};

const configureAnalytics = async (user) => {
  const { userId, tenantId, email, companyName, emailDomain, role } = user;
  
  analyticsSettings.disabled = false;
  analyticsSettings.AWSPinpoint.endpointId = userId;
  analyticsSettings.AWSPinpoint.endpoint.address = email;
  analyticsSettings.AWSPinpoint.endpoint.attributes.tenantId = [tenantId];
  analyticsSettings.AWSPinpoint.endpoint.attributes.eventName = analyticsSettings.AWSPinpoint.endpoint.attributes.eventName || [];
  analyticsSettings.AWSPinpoint.endpoint.userId = userId;
  analyticsSettings.AWSPinpoint.endpoint.userAttributes.tenantId = [tenantId];
  analyticsSettings.AWSPinpoint.endpoint.userAttributes.userId = [userId];
  analyticsSettings.AWSPinpoint.endpoint.userAttributes.companyName = [companyName];
  analyticsSettings.AWSPinpoint.endpoint.userAttributes.emailDomain = [emailDomain];
  analyticsSettings.AWSPinpoint.endpoint.userAttributes.role = [role];
  // not sure if we can configure just Analytics at this point
  Amplify.Analytics.configure(analyticsSettings);
  Amplify.Analytics.autoTrack('session', {
    enable: true,
    attributes: {
      tenantId,
      userId
    },
  });

  Amplify.Analytics.autoTrack('pageView', {
    enable: true,
    eventName: 'user-page-view',
    attributes: {
        tenantId,
        userId
    },
    type: 'SPA',
    getUrl: () => {
      return window.location.origin + window.location.pathname;
    }
  });

  Amplify.Analytics.autoTrack('event', {
    enable: true,
    events: ['click'],
    selectorPrefix: 'data-cc-analytics-',
    provider: 'AWSPinpoint',
    attributes: {
      tenantId,
      userId
    }
  });

  Amplify.Analytics.enable();
};

const FederatedSignin = props => {
  const [tenant, setTenant] = useState(null);
  const [token, setToken] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [formType, setFormType] = useState(FormType.EMAIL_LOOKUP);
  const [email, setEmail] = useState(undefined);
  const location = useLocation();

  const getToken = () => {
    return Auth.currentSession()
    .then(session => session)
    .catch(err => console.log(err));
  }

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
    .then(user => user)
    .catch(err => console.log(err));
  }

  useEffect(() => {
    parseParams();
    // setupCognito();
    try {
      const currentUser = Auth.currentAuthenticatedUser();
    } catch (error) {
      console.error(error);
    }

    Hub.listen("auth", ({payload: {event, data}}) => {
      switch (event) {
        case "signIn":
        case "cognitoHostedUI":
          setToken("grating...");
          getToken().then(userToken => setToken(userToken.idToken.jwtToken));
          getUser().then(userData => setUser(userData));
          break;
        case "signOut":
          setToken(null);
          break;
        case "signIn_failure":
        case "cognitoHostedUI_failure":
          break;
      }
    });
  },[]);
 
  /**
   * Parse out the cognito params from the url
   * These params are stringified and encoded
   */
  const parseParams = () => {
    const functionName = "parseParams"; 

    try {
      const tenantParams = new URLSearchParams(location.search).get("tenant");
      if (tenantParams) {
        const decodedParams = decodeURIComponent(tenantParams);
        const tenantForAuth = JSON.parse(decodedParams); 
        setTenant(tenantForAuth);
      }

    } catch (error) {
      console.error({functionName, location, error: error.toString()});
      throw new Error(error);
    }
  };

  /**
   * Set up Cognito based on the user's email
   */
  useEffect(() => {
    setupCognito();
    setForm();
    if (tenant) {
      try {
        Auth.currentAuthenticatedUser().then(user => { 
          props.cognitoLoginSuccess(user);
          Auth.currentSession().then(session => {
          });
          if (isOnboarding(user)) {
            props.history.push('/onboarding');
          } else {
            props.history.push('/dashboard');
          }
        });
      } catch (error) {
        console.error({functionName:"useEffect", info: "currentAuthenticatedUser", error: error.toString()});
      }
    }
  }, [tenant]);

  /**
   * Grab the tenant information and cognito/sso info given the user's email
   * Note: the user must already be registered for an account
   * @param {String} email 
   */
  const setupCognito = async () => {
    
    const tenantData = window.localStorage.getItem('my_tenant_data');
    if (tenantData) {
      const theTenant = JSON.parse(tenantData);
      const region = theTenant.region ? theTenant.region : "us-west-2";
      authSettings.userPoolId = theTenant.userPoolId;
      authSettings.identityPoolId = theTenant.identityPoolId;
      authSettings.userPoolWebClientId = theTenant.appClientId;
      authSettings.oauth.domain = `${theTenant.tenantId.toLowerCase()}.auth.${region}.amazoncognito.com`;
  
      Amplify.configure({
        Auth: authSettings,
      });
    }
  }

  const handleEmailLookup = async (event) => {
    const functionName = "handleEmailLookup";
    event.preventDefault();
    setIsLoading(true);
    
    try {
      window.localStorage.removeItem('my_tenant_data');
      const email = event.target.email.value;
      // lookup tenant for given email (we have to make emails URI safe)
      const data = await APIManager.Instance.call("GET", APIUrls.getTenant(email));
      const { tenant } = data; 
      window.localStorage.setItem('my_tenant_data', JSON.stringify(tenant));
      setTenant(tenant);
    } catch (error) {
      window.localStorage.removeItem('my_tenant_data');
      console.error({functionName, event, error: error.toString()});
      throw new Error(error);
    }
  };

  // /////////////////////////////////////////////////////////////////////////////////
  // Forms

  const setForm = () => {
    if (tenant && tenant.sso) {
      if (tenant.sso === FormType.OKTA) {
        setFormType(FormType.OKTA);
      }
    }
  };

  const renderEmailLookupForm = () => {
    return (
      <Form className="signup-form" onSubmit={handleEmailLookup}>
      
        <Form.Group controlId="email" size="sm">
          <Form.Label>Work Email</Form.Label>
          <Form.Control
            autoFocus
            type="email"
            name="email"
            placeholder="yourwork@email.com"
            value={email}
          />
        </Form.Group>
        <LoaderButton
          block
          size="sm"
          type="submit"
          isLoading={isLoading}
          text="Sign In"
          loadingText="Signing In…"
          className="btn-danger"
        /> 
        <div>
        <Link to="/login">Sign in without SSO {">"}</Link><br />
        </div>
      </Form>
    );
  };

  const renderOktaForm = () => {
    return (
      <div>
        <p>Ok! It looks like you're using <strong>Okta</strong></p><br/>
        <Button
          onClick={authWithOkta}
        >
          Sign In with Okta
        </Button> 
        <div> 
          <br/>
        <Link to="/login">Sign in without SSO {">"}</Link><br />
        </div>
      </div>
    );
  };

  const authWithOkta = () => {
    try {
      Auth.federatedSignIn({provider: "Okta"}).then(user => {
        const authUser = Auth.currentAuthenticatedUser();
        return authUser;
      });
    } catch (error) {
      console.error({functionName: "authWithOkta", error: error.toString()});
    }
  };

  const renderFormByType = () => {

    switch (formType) {
      case FormType.EMAIL_LOOKUP:
        return renderEmailLookupForm();
      case FormType.OKTA:
        return renderOktaForm();
      default:
        return renderEmailLookupForm();
    }
  }

  return (
    <div className="Signup">
        <div className="left-panel"> 
          <img src={imgSignup} alt="signup to Content Camel" />
        </div>
        <div className="right-panel">
          <img className="camel-logo" src={imgCamelLogo} alt="content camel logo"/>
            <div className="signup-wrapper">
              <div>
                <div className="signup-title">
                  <h3>Sign on with your authentication provider 🔑.</h3>
                </div>
              </div>
              {renderFormByType()}
            </div>
          {/* {error && <p className="error">{error}</p>} */}
        </div>
      </div>
  );
};

const mapStateToProps = state => ({
  user: state.auth.tenant
});

const mapDispatchToProps = dispatch => 
  bindActionCreators({
    loginSuccess,
    cognitoLoginSuccess,
    cognitoLoginFail,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FederatedSignin);
